<template>
    <div class="anjian">
        <div v-wechat-title="$route.meta.title"></div>
        <!--TopBar></TopBar-->
        <div class='card-right-top'>
            <Card style="min-width: 1330px;">
                <div>
                    <div style="background-color:#F2F2F2 ; color: #E8410B;margin-bottom: 20px; text-align: center;">严守公司经营道德红线:
                        1.严禁泄露客户资料2.严禁做假资料3.严禁私自留存客户信息(征信报告、身份证复印件、客户名单)一经发现， 严肃处理并且保留追责权利!
                    </div>
                    <div class="sousuo" style="width: 100%">
                        <div style="width: 450px" class="yl-flex flex_between">
                            <Input placeholder="搜索客户姓名/电话" v-model="name" style="width: 300px">
                                <i-button slot="append" icon="ios-search"></i-button>
                            </Input>
                            <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                        </div>
                    </div>
                    <div class="multiple" style="width: 100%" >
                        <Table :columns="department_columns" :data="datas" size="small" ref="table">
                            <template slot-scope="{ row }" slot="name">
                                <div style="display: flex; align-items: center;">
                                    <div v-if="row.type == 1 "
                                         style="width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%;">
                                        个
                                    </div>
                                    <div v-if="row.type == 2 "
                                         style="width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">
                                        企
                                    </div>
                                    <div style="display: flex;flex-direction: column; align-items: center;">
                                        <span>{{row.name}}</span>
                                        <span>{{row.phone}}</span>
                                    </div>
                                </div>
                            </template>
                            <template slot-scope="{ row }" slot="make_state">
                                <img v-for="(item, index) in row.make_state" style="width: 20px; margin-top: 5px" :src="item"/>
                                <div v-if="row.make_state.length == 0">无</div>
                            </template>
                            <template slot-scope="{ row }" slot="entrust">
                                <div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">{{item.created_at}} {{item.content}}</div>
                                <div v-if="row.entrust.length == 0">无</div>
                            </template>
                        </Table>
                    </div>

					<div class="pager">
						<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
							:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
					</div>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
    import TopBar from '../topbar/TopBar.vue';
    import {mapActions, mapGetters} from "vuex";
    import {
        getList,
		getClickList
    } from '@/api/client';
    export default {
        name: "Client",
        components: {
            TopBar
        },
        computed: {
            ...mapGetters(['userInfo', 'token'])
        },
        mounted: function() {
			this.search_data = this.$route.query
			if(this.search_data.timePeriodDate){
				this.search_data.timePeriodDate = this.$route.query.timePeriodDate.split(',');
			}		
            this.getList();
        },
        data() {
			var that = this;
            return {
                name: '',
                count: 0,
                page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 200,500],
				search_data:[],
				start:[],
                datas: [
                ],
                department_columns: [{
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                    {
                        "title": "跟进人",
                        "key": "follow_name",
                        "width": 60,
                        filters: [],
                        filterMultiple: false,
                        filterMethod(value, row) {

                        }
                    },
                    {
                        "title": "客户",
                        "slot": "name",
                        "width": 100
                    },
                    {
                        "title": "性别",
                        "key": "sex_name",
                        "width": 50,
                    },
					{
					    "title": "星级",
					    "key": "start_name",
					    "width": 60,
					},
                    {
                        "title": "媒体代码",
                        "key": "media_name",
                        "width": 80
                    },
                    {
                        "title": "需求额度",
                        "key": "loans_money",
                        "width": 70,
                    },
                    {
                        "title": "跟进记录",
                        // "key": "entrust",
                        slot: 'entrust',
                        "width": 120
                    },
                    {
                        "title": "申请时间",
                        "key": "applied_at",
                        "width": 100,
                        "sortable": true
                    },
                    {
                        "title": "进线时间",
                        "key": "join_at",
                        "width": 100,
                        "sortable": true
                    },
                    {
                        "title": "跟进时间",
                        "key": "next_follow_at",
                        "width": 100,
                        "sortable": true
                    },
                    {
                        "title": "跟进次数",
                        "key": "follow_times",
                        "width": 50
                    }
                ],
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            search() {
                this.page = 1;
                this.getList();
            },
            changePage(e) {
                this.page = e;
                this.getList();
            },
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			mySearchByFollow(followUid) {
			    this.followUid = followUid;
			    this.page = 1;
			    this.getList();
			},
			mySearchByMoney(loanMoney) {
			    this.loanMoney = loanMoney[0];
			    this.page = 1;
			    this.getList();
			},
			mySearchByContact(call_tag) {
			    this.call_tag = call_tag;
			    this.page = 1;
			    this.getList();
			},
			mySearchByStart(start) {
			    this.start = start;
			    this.page = 1;
			    this.getList();
			},
            async getList() {
                let that = this;
                var data = this.search_data;
                data.menu = 'shop_client';
                data.token = this.token;
                data.page = this.page;
                let res = await getClickList(that, data);
                that.datas = res.data.list;
                that.count = res.count;
            },
        }
    }
</script>

<style lang="less">
    .top-add {
        position: relative;
        width: 30px;
        left: 80%;
        bottom: 33px;
    }

    .input-text {
        margin-top: 30px;
        display: flex;
        justify-content: left;
        align-items: center;

        div {
            margin: 0 10px;
        }
    }
    .top-save {
        position: relative;
        left: 70%;
        top: -30px;
    }

    .cascader {
        width: 380px;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
            font-size: 12px;
        }
        span{
            font-size: 10px;
        }
    }

    .chongzhi {
        position: absolute;
        top: 16px;
        left: 280px;
    }

    .sousuo {
        height: 32px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 20px;
    }
    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .ivu-table-header thead tr th {
        text-align: center !important;
    }

    .ivu-table-cell {
        padding-left: 2px;
        padding-right: 2px;
        text-align: center;
    }

    .ivu-table table {
        width: 100% !important;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
</style>
